module.exports = [{
      plugin: require('C:/Users/Matt/Documents/GitHub/investors/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
